// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"231afc61","703":"fd31337a","787":"99a835c8"}[chunkId] + ".chunk.js";
};